// extracted by mini-css-extract-plugin
module.exports = {"container":"trustpilot-score_container__QnEJ3","trustpilotStars":"trustpilot-score_trustpilotStars__FTRLp","trustpilotLogo":"trustpilot-score_trustpilotLogo__SgYJO"};